import React, {} from 'react';

import BaseElement from '../base';

function NumberedList(props) {

  function renderList() {

    const { attributes, children } = props;

    const orderedListContainerAttributes = {
      ...attributes,
      className: ''
    };

    const orderedListAttributes = {
      className: 'ordered-list'
    };

    return <div {...orderedListContainerAttributes}>
      <ol {...orderedListAttributes}>{children}</ol>
    </div>;

  }

  function renderMain() {

    return <BaseElement {...props}>
      {renderList()}
    </BaseElement>;

  }

  return renderMain();

}

export default NumberedList;